import { Controller } from 'stimulus'

export default class JobFiltersController extends Controller {
  static targets = ['job', 'officeGroup', 'locationFilter', 'teamFilter', 'contractFilter']

  filter() {
    const location = this.hasLocationFilterTarget ? this.locationFilterTarget.value : ''
    const team = this.hasTeamFilterTarget ? this.teamFilterTarget.value : ''
    const contract = this.hasContractFilterTarget ? this.contractFilterTarget.value : ''

    this.jobTargets.forEach((job) => {
      const jobLocation = job.dataset.locationKey || ''
      const jobTeam = job.dataset.teamId || ''
      const jobContract = job.dataset.contractType || ''
      const isRemote = job.dataset.isRemote === 'true'

      const matchLocation =
        !location || jobLocation === location || (location === 'remote' && isRemote)
      const matchTeam = !team || jobTeam === team
      const matchContract = !contract || jobContract === contract

      if (matchLocation && matchTeam && matchContract) {
        job.style.display = ''
      } else {
        job.style.display = 'none'
      }
    })

    this.updateGroupVisibility()
  }

  updateGroupVisibility() {
    this.officeGroupTargets.forEach((group) => {
      const jobs = group.querySelectorAll('[data-target="job-filters.job"]')
      const visibleJobs = Array.from(jobs).filter((job) => job.style.display !== 'none')

      if (visibleJobs.length === 0) {
        group.style.display = 'none'
      } else {
        group.style.display = ''
      }
    })
  }

  resetFilters() {
    if (this.hasLocationFilterTarget) {
      this.locationFilterTarget.value = ''
    }
    if (this.hasTeamFilterTarget) {
      this.teamFilterTarget.value = ''
    }
    if (this.hasContractFilterTarget) {
      this.contractFilterTarget.value = ''
    }
    this.filter()
  }
}
